import { LoaderNew, ModalDialog, ModBox } from '@jfs/ui-new'

export const FullScreenLoader = ({ show }: any) => {
  return (
    <ModalDialog show={show} type="Centered">
      <ModBox position={'absolute'} top={0} left={0} right={0} bottom={0} backgroundColor={'TRANSPARENT45'}>
        <LoaderNew type={'large'} color={'PRIMARY'} />
      </ModBox>
    </ModalDialog>
  )
}
